module.exports = __webpack_public_path__ + "static/media/150.f77589c6.png";